import { getEnvVariable } from "@/business/shared/commons/envUtils/getEnvVariable";
import { exportImagesLastUpdateExcelUrl } from "@/business/inventory/infrastructure/constants/urls";

export const exportImagesLastUpdateExcel = {
    async execute(): Promise<string> {
        return getEnvVariable
            .execute("VUE_APP_DACCACH_URL")
            .concat(exportImagesLastUpdateExcelUrl);
    },
};
